export default class Chatty {
    constructor(deviceOutput) {
        const product = window.location.href.includes('/girokonto') ? 'gc' : 'cc';
        if (window.Check24) {
            this.init(product, deviceOutput);
        }
    }

    isProduction() {
        return window.location.hostname.endsWith('check24.de');
    }

    getGirokontoConfig() {
        return {
            chatFlowName: 'girokonto.desktop',
            chatflowEntry: 'start_SEO',
            name: 'gc-chatty-seo'
        };
    }

    getCreditCardConfig() {
        return {
            chatFlowName: 'kreditkarte.neu',
            chatFlowEntry: 'start_from_resultPage',
            name: 'cc-chatty-seo'
        };
    }

    getConfig(product) {
        if (product === 'gc') {
            return this.getGirokontoConfig();
        }
        return this.getCreditCardConfig();
    }

    init(product, deviceOutput) {
        const {
            chatFlowName, chatFlowEntry, name
        } = this.getConfig(product);
        const config = this.getChattyConfig({
            chatFlowName,
            chatFlowEntry,
            name,
            deviceOutput
        });

        if (window.Check24?.loader && window.C24App) {
            window.Check24.loader.useChatbotApp = true;

            // eslint-disable-next-line no-unused-expressions
            window.C24App.setSupportDialogHandler(() => {
                window.C24App.triggerChattyWithOptions({
                    ...config.chatbot.client,
                    presentationType: 'sheet',
                    sheetState: 'full'
                });
                return true;
            });
        }

        const hasConsent = document.cookie.includes('c24consent');

        if (hasConsent) {
            window.Check24.loader.setContactLayer(config, true);
        } else {
            window.addEventListener('c24consent', () => {
                window.Check24.loader.setContactLayer(config, true);
            });
        }
    }

    getChattyConfig(params) {
        const {
            chatFlowName,
            chatFlowEntry,
            name,
            deviceOutput
        } = params;

        const removeChatUrlParameter = url => url.replace(/[?&]showchat=1(?:[?&]|$)/g, '');

        const chatbotConfig = {
            client: {
                controlServerAddress: this.isProduction() ? 'https://api.chat.check24.de' : 'https://api.chat.check24-test.de',
                chatFlowName,
                chatFlowRelease: 'active',
                chatFlowEntry,
                clientDetails: {
                    __creditcard: {
                        url: removeChatUrlParameter(window.location.href)
                    },
                    __girokonto: {
                        url: removeChatUrlParameter(window.location.href)
                    }
                }
            },
            env: this.isProduction() ? 'prod' : 'test',
            deviceoutput: deviceOutput,
            forceNewSession: false
        };

        return {
            chattyVersion: '2.48',
            env: this.isProduction() ? 'prod' : 'test',
            onDemand: true,
            type: 'chatty',
            name: name || 'chatty-seo',
            deviceoutput: deviceOutput,
            chatbot: chatbotConfig,
            contact: {
                layer: {
                    active: false,
                    openChatEvent: 'c24-chat-chatty-open',
                    contactLink: 'https://check24.de/unternehmen/kontakt/?sec=fin'
                }
            }
        };
    }
}
